import { Routes } from '@angular/router';
import { NutrigenicComponent } from './nutrigenic.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogDetailComponent } from './pages/blog/blog-detail/blog-detail.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ActivateComponent } from './pages/activate/activate.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { FaqComponent } from './pages/faq/faq.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { HowItWorksPageComponent } from './pages/how-it-works-page/how-it-works-page.component';
import { EditWeekPlanComponent } from './pages/edit-week/edit-week-plan/edit-week-plan.component';
import { CurrentMenuComponent } from "./pages/current-menu/current-menu.component";
import { OrderFlowComponent } from './pages/order-flow/order-flow.component';
import { OrderSummaryComponent } from './pages/order-flow/order-summary/order-summary.component';
import { OrderCheckoutComponent } from './pages/order-flow/order-checkout/order-checkout.component';
import { SelectMealsComponent } from './pages/order-flow/select-meals/select-meals.component';
import { NgForBusinessComponent } from './pages/ng-for-business/ng-for-business.component';

export const NutrigenicRoutes: Routes = [
    {
        path: '',
        component: NutrigenicComponent,
        children: [
            { path: '', component: HomeComponent },
            { path: 'home', component: HomeComponent },
            { path: 'current-menu', component: CurrentMenuComponent },
            { path: 'about-us', component: AboutUsComponent },
            { path: 'blog', component: BlogComponent },
            { path: 'blogDetail', component: BlogDetailComponent },
            { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
            { path: 'faq', component: FaqComponent },
            { path: 'privacy', component: PrivacyComponent },
            { path: 'terms', component: TermsComponent },
            { path: 'how-it-works', component: HowItWorksPageComponent },
            { path: 'activate/:token', component: ActivateComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'edit-week-plan', component: EditWeekPlanComponent },
            { path: 'order-flow', component: OrderFlowComponent },
            { path: 'order-summary', component: OrderSummaryComponent },
            { path: 'order-checkout', component: OrderCheckoutComponent, canActivate: [AuthGuard] },
            { path: 'ng-for-business', component: NgForBusinessComponent },
            { path: 'select-meals', component: SelectMealsComponent }
        ]
    }
];
